import { firebaseDB } from '@/config/firebaseConfig'

const state = {
  isLoading: true,
  categoryList: []
}

const mutations = {
  'UPDATE_CATEGORY_LIST' (state, payload) {
    state.categoryList = payload
    state.isLoading = false
  },
  'DELETE_CATEGORY' (state, index) {
    state.categoryList.splice(index, 1)
  }
}

const actions = {
  async getCategoryList ({ commit, getters, dispatch }) {
    const shopRef = firebaseDB().ref('stores/' + getters.shopId)
    return shopRef.child('categories').on('value', categories => {
      const myCategories = []
      if (!categories.exists()) { // get categories from products
        if (getters.products.length) {
          getters.products.forEach((product) => {
            if (product.category && !myCategories.includes(product.category)) {
              console.log(product.category)
              myCategories.push(product.category)
            }
          })
          dispatch('updateCategories', myCategories)
        }
      } else {
        categories.forEach(element => {
          myCategories.push(element.val())
        })
        commit('UPDATE_CATEGORY_LIST', myCategories)
      }
    })
  },
  addCategory ({ commit, state }, tag) {
    let newArr = state.categoryList
    newArr.push(tag)
    commit('UPDATE_CATEGORY_LIST', newArr)
  },
  updateCategory ({ commit, getters, state }) {
    commit('UPDATE_CATEGORY_LIST', state.categoryList)
    return firebaseDB().ref(`stores/${getters.shopId}/categories`).set(state.categoryList)
  },
  deleteCategory ({ commit, getters, state }, index) {
    commit('DELETE_CATEGORY', index)
    return firebaseDB().ref(`stores/${getters.shopId}/categories`).set(state.categoryList)
  },
  updateCategories ({ commit, getters }, payload) {
    commit('UPDATE_CATEGORY_LIST', payload)
    return firebaseDB().ref(`stores/${getters.shopId}/categories`).set(state.categoryList)
  }
}

const getters = {
  categories: state => state.categoryList,
  isCategoryLoading: state => state.isLoading
}

export default {
  state,
  mutations,
  actions,
  getters
}
